import { View } from './view'

export const LoginAs = View
